export default "__VITE_ASSET__95ff834a__"